import React from 'react'
import { TypeGuards } from '@codeleap/types'
import { useLingui } from '@lingui/react/macro'
import { phones } from '@/config'

const options = Object.values(phones)

export type PhoneProps = {
  applyMask: string
  name: string
  code: string
  iso: string
  flag: string
  mask: string
  label: string
  maskPlaceholder: string
  value: string
  description: string
}

export type UsePhoneOptions = {
  disableInternalization?: boolean
  defaultLocale?: string
  initialLocale?: string
}

const DEFAULT_LOCALE = 'GB'

export const usePhoneOptions = (props: UsePhoneOptions) => {
  const {
    defaultLocale = DEFAULT_LOCALE,
    initialLocale = null,
    disableInternalization = false,
  } = props
  
  const { i18n } = useLingui()

  const localeArray = i18n.locale?.split?.('-')
  const localeIso = localeArray?.[localeArray?.length - 1]

  const iso = TypeGuards.isString(initialLocale)
    ? initialLocale
    : (localeIso ?? defaultLocale)

  const localePhone: PhoneProps = React.useMemo(() => {
    let phone = null

    if (disableInternalization) {
      phone = options?.filter?.(option => option?.iso === (initialLocale ?? defaultLocale))
    } else {
      phone = options?.filter?.(option => option?.iso === iso)
    }

    return phone?.[0] ?? options?.[0]
  }, [iso])

  return {
    phones,
    options,
    localePhone,
  }
}